import DownloadIcon from "@assets/images/down-arrow.svg";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@saleor/components/Container";
import PageHeader from "@saleor/components/PageHeader";
import React from "react";

import BatchHistory from "../BatchHistoryList";

const useStyles = makeStyles(
  () => ({
    download: {
      backgroundColor: "#FFD15C",
      borderRadius: "6px",
      height: "35px",
      width: "35px"
    },
    imgDownload: {
      width: "20px"
    }
  }),
  { name: "BatchHistoryListPage" }
);

function BatchHistoryListPage(props) {
  const { download, ...batchHistoryListProps } = props;
  const classes = useStyles(props);

  return (
    <Container>
      <PageHeader title="Batch History">
        <IconButton
          color="primary"
          className={classes.download}
          disabled={!batchHistoryListProps.selected}
          onClick={download}
        >
          <img src={DownloadIcon} className={classes.imgDownload} />
        </IconButton>
      </PageHeader>
      <Card>
        <BatchHistory {...batchHistoryListProps} />
      </Card>
    </Container>
  );
}

export default BatchHistoryListPage;
